import { Text, Title, Body } from './components';

export const Typography = {
  Text,
  Title,
  Body,
};
